
import React, { useState, useRef, useEffect } from "react";
import Dropdown from "../Dropdown";
import DateInput from "../DateInput";
import closeIcon from "../../Assets/Icons/close.png";
import { postData } from "../../ApiServices/ApiService";
import { ORG_UPDATE_TO_DO_STATUS,ORG_UPCOMING_APPOINTEMNTS_MEATING_STATUS } from "../../ApiServices/BaseURL";
import Loader from "../Loader";
import {convertGMTToLocal} from '../../Utils/Validation'

const ScheduleReminderCompleteModal = ({ isOpen, onClose, selectedUpcomingInfo, fetchUpcomingAppointemntsList }) => {

  const handleClose = () => {
    onClose();
    setError('');
  }

  const dropDownOptions = [
    // { "label": "IN-Progress", "value": 2 },
    { "label": "Attended", "value": 1 },
    { "label": "Not Attended", "value": 2 }
  ]
  const [dropdownValue, setDropdownOptions] = useState({
    "label": "",
    "value": 2
  });

  const [dateTime, setDateTime] = useState("");

  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

      const dropdownRefs = useRef({}); // Ref for dropdown
  
      // Handle clicks outside dropdowns
      useEffect(() => {
          const handleClickOutside = (event) => {
              const isOutside = Object.keys(dropdownRefs.current).every(
                  (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
              );
              if (isOutside) {
                  setOpenDropdown(null);
              }
          };
  
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
              document.removeEventListener("mousedown", handleClickOutside);
          };
      }, []);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('')

  useEffect(() => {
    //console.log('selectedUpcomingInfo:--',selectedUpcomingInfo);
    if (selectedUpcomingInfo) {
      setDropdownOptions({
        label: selectedUpcomingInfo?.sc_status_name,
        value: selectedUpcomingInfo?.sc_status
      })
      // setDateTime(selectedUpcomingInfo?.sc_time.replace(' ','T'))
    //   const formattedDateTime = convertGMTToLocal(selectedUpcomingInfo?.sc_time,"yyyy-MM-dd HH:mm:ss");
    //     const isoDateTime = new Date(formattedDateTime.replace(" IST", "")).toISOString().slice(0, 16); 
    //     setDateTime(formattedDateTime);
    }


  }, [selectedUpcomingInfo]);

  const handleUpdate = async () => {
    try {
      setError('');
      setSuccess('');
    //   if (!dateTime) {
    //     setError('Date is required'); return
    //   }
      setLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      // const locationValue = location === 'Online' ? 2 : 1;
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        // "emp_id": storedUserInfo?.emp_id,
        "action": "UPDATE_APPOINTMENT_STATUS",
        // "sc_time": dateTime.replace('T',' '),
        "sc_id": selectedUpcomingInfo?.sc_id,
        "is_emp_attended": dropdownValue?.value
      }
      //console.log('ToDo status payload', payLoad);
      // Make the API call
      const response = await postData(ORG_UPCOMING_APPOINTEMNTS_MEATING_STATUS, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setError('')
            // setEmployeeList(responseData?.dataJ || []);
            setSuccess(responseData?.info);
            setTimeout(() => {
              fetchUpcomingAppointemntsList();
              handleClose();
              setSuccess('');

            }, 3000);
          } else {
            setError(responseData?.info || 'Failed to update upcoming appointment status. Please try again.');
          }
        } else {
          setError(responseData?.info || 'Failed to update upcoming appointment status.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to update upcoming appointment. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setError(`Failed to update upcoming appointment. Please check your network connection and try again.`);
      }
    } finally {
      setLoading(false);
    }
  }

  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: 270, borderRadius: '10px 0px 0px 10px' }}>
        <button className="close-button" onClick={() => { handleClose(); }}>
          <img src={closeIcon} alt="Close" style={styles.closeIcon} />
        </button>
        <h2 className="modal-title">Appointment Complete</h2>
        <hr className="title-divider" />

        <div className="form-grid" style={{ display: 'flex', flexDirection: 'column' }}>
          <Dropdown
            ref={(el) => (dropdownRefs.current[" "] = el)}
            isOpen={openDropdown === " "}
            toggleDropdown={() => toggleDropdown(" ")}
            label="Appointment Status"
            options={dropDownOptions}
            value={dropdownValue}
            onChange={setDropdownOptions}
          />
          {/* <div>
            <label style={{ fontSize: '12px', color: '#343C44' }}>Update Due Date</label>
            <DateInput
              value={dateTime}
              onChange={(e) => setDateTime(e.target.value)}
              isDateTime={true}
            />
          </div> */}

        </div>
        <hr className="footer-divider" />
        {error && <div className="list-error-msg" style={{ padding: 0 }}> {error}</div>}
        {success && <div className="list-success-msg" style={{ padding: 0 }}> {success}</div>}

        <div className="button-container">
          <button className="add-client-button" onClick={handleUpdate} style={{ opacity: loading ? 0.5 : 1 }} disabled={loading}> {loading &&
            <span style={{ paddingRight: 5 }} ><Loader loading={loading} color={'var(--background-color)'} size="small" /> </span>
          } Update</button>
          <button className="cancel-button" onClick={() => { handleClose(); }}>Cancel</button>
        </div>
      </div>
    </div>
  )

}

const styles = {
  closeIcon: {
    width: "12px",
    height: "12px",
  },
}

export default ScheduleReminderCompleteModal;

